// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"MenuBar_menuBar__82314","anchor":"MenuBar_anchor__45d30"};